// eslint-disable-next-line spaced-comment
export default ({ size } = {}) => /*html*/`
<svg width="${ size }" height="${ size }" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.272991 5.96476L5.53921 0.674216C5.90319 0.308546 6.49177 0.308546 6.85189 0.674216L7.72701 1.55338C8.091 1.91905 8.091 2.51035 7.72701 2.87213L3.99419 6.62219L7.72701 10.3722C8.091 10.7379 8.091 11.3292 7.72701 11.691L6.85189 12.5702C6.4879 12.9358 5.89932 12.9358 5.53921 12.5702L0.272991 7.27961C-0.090997 6.92172 -0.090997 6.33043 0.272991 5.96476Z" fill="#595959"/>
</svg>

`
